"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emotionNameStyles = exports.getIndividualEmotionStyles = exports.getFormControlLabelStyles = exports.getRadioGroupStyles = exports.wrapperStyles = void 0;
exports.wrapperStyles = {
    display: 'flex',
    paddingBottom: 0,
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '0.75rem',
    alignSelf: 'stretch',
};
const getRadioGroupStyles = (backgroundColor) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.25rem',
    alignSelf: 'stretch',
    backgroundColor: backgroundColor === 'White' ? 'backgrounds.white' : 'backgrounds.neutral',
});
exports.getRadioGroupStyles = getRadioGroupStyles;
const getFormControlLabelStyles = (showAsSelected) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.25rem',
    padding: '0.5rem',
    border: showAsSelected ? '0.063rem solid' : 'none',
    borderRadius: showAsSelected ? '0.5rem' : 'none',
    borderColor: showAsSelected ? 'secondary.main' : 'none',
    cursor: 'pointer',
    margin: 0,
});
exports.getFormControlLabelStyles = getFormControlLabelStyles;
const getIndividualEmotionStyles = (backgroundColor) => ({
    color: 'secondary.main',
    '&:hover': {
        backgroundColor: backgroundColor === 'White' ? 'backgrounds.white' : 'backgrounds.neutral',
    },
    '> svg': {
        width: '2.08rem',
        height: '2.08rem',
    },
});
exports.getIndividualEmotionStyles = getIndividualEmotionStyles;
exports.emotionNameStyles = {
    whiteSpace: 'nowrap',
};
//# sourceMappingURL=SmileRating.styles.js.map